import { useParams } from "react-router-dom";
import Loading from "./Loading";
import { useEffect, useState } from "react";
import axios from "axios";
import ProductShow from "../Components/ProductShow";
import SubTitle from "../Components/SubTitle";
import { URL } from "../config";


const Announcement = () => {
    const { id ,title} = useParams();
    const [titles,setTitles]=useState([]);
    const [products,setProducts]=useState([]);
    const [nextPage,setNextPage]=useState('');
    const [path,setPath]=useState('');
    const [load,setLoad]=useState(false);
    useEffect(()=>{
        setTitles([{
            name:title,
             link:'' 
         }
     ]);
        setLoad(true);
        axios.get(`${URL}/api/product/announcement/${id}`)
        .then(function (response) {
          if(response.data.success){
            setProducts(response.data.data.data);
            setNextPage(response.data.data.next_page_url);
            setPath(response.data.data.path);
          }
          setLoad(false);
            })
        .catch(function (error) {
          console.log('error');
          setLoad(false);
        });
      },[id])
if(load)
    return <Loading/>
  return (
    <div className='container-fluid mt-lg-5 pt-5 mb-2'>
    <SubTitle titles={titles}/>
    <ProductShow products={products} nextPage={nextPage} nextPath={path} titles={titles}/>
</div>
  )
}

export default Announcement